module.exports = __webpack_public_path__ + "img/play3_pc@2x.6000ba04.png";